import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  ButtonContainer,
  CompletedButton,
  InProgressButton,
  DraftButton,
} from "./AnalyticalStatus.styled";

const AnalyticalStatus = (props) => {
  const { t, status } = props;
  return (
    <ButtonContainer>
      <div>
        {status === 1 && <DraftButton>{t("DRAFT")}</DraftButton>}
        {status === 2 && (
          <InProgressButton>{t("IN_PROGRESS")}</InProgressButton>
        )}
        {status === 3 && <CompletedButton>{t("COMPLETED")}</CompletedButton>}
      </div>
    </ButtonContainer>
  );
};

AnalyticalStatus.propTypes = {
  status: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(AnalyticalStatus);
